import { KYBView } from "./components/KYBView";
import { RootView } from "./components/RootView";
import { BillingView } from "./components/BillingView";
import { useOnboardingController } from "./controller";
import { View } from "./types";
import { IDVView } from "./components/IDVView";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Logout01 } from "untitledui-js-base";
import { useAuthContext } from "providers/Auth";
import logoSquare from "shared/branding/logo-square.svg";

import { getErrorMessage } from "utils/error";
import { logout } from "api/landlord/auth";
import { Loader } from "shared/components/Loader";
import { Redirect } from "shared/components/Redirect";
import { VerificationNames } from "shared/types";
import { toast } from "react-toastify";

export const OnboardingView = () => {
  const { view, setView, onboardingMeta } = useOnboardingController();
  const { refreshAuth, auth } = useAuthContext();
  const navigate = useNavigate();

  if (onboardingMeta.isLoading)
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-900">
        <Loader />
      </div>
    );

  if (auth?.partner.status === "active") return <Redirect href="/" />;

  if (!onboardingMeta.data) return null;

  return (
    <div className="min-h-screen bg-background-900">
      <div className="flex items-center justify-between bg-background-1000 px-6 py-4">
        {view !== View.Default ? (
          <div className="flex-1">
            <Button onClick={() => navigate("/onboarding")} Icon={ArrowLeft}>
              Back
            </Button>
          </div>
        ) : (
          <div className="flex-1" />
        )}
        <div className="flex-1">
          <img alt="Boom logo" className="flex h-10 w-10" src={logoSquare} />
        </div>
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.SM}
          borderLess
          className="cursor-pointer stroke-content-1000 text-content-1000 hover:bg-primary-20 hover:stroke-primary-500 hover:text-primary-500"
          Icon={Logout01}
          onClick={() => {
            logout()
              .then(refreshAuth)
              .catch((err) => {
                toast.error(
                  getErrorMessage(err, "Logging failed unexpectedly")
                );
              });
          }}
        >
          Logout
        </Button>
      </div>
      {view === View.Default ? (
        <RootView setView={setView} data={onboardingMeta.data} />
      ) : view === View.KYB ? (
        <KYBView setView={setView} refresh={onboardingMeta.refetch} />
      ) : view === View.Billing ? (
        <BillingView data={onboardingMeta.data.billing} />
      ) : // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- this is fine
      view === View.IDV ? (
        <IDVView
          setView={setView}
          data={onboardingMeta.data[VerificationNames.IdentityVerification]}
        />
      ) : null}
    </div>
  );
};
